import React from 'react'
import style from './member.module.css'
import Page from '../../components/layout/page.component'

export default function BeMember() {
    return <Page
        width='narrow'
        eyebrow='Acesso VIP'
        title='Seja um membro VIP!'
        subtitle='Conteúdo exclusivo e em constante evolução do Partitura VIP.'>
        <div className={style.card}>
            <p className={style.price}><span>R$30,00</span> / ano</p>
            <p>Para ter acesso, basta fazer um pagamento anual via PIX.</p>
            <div className={style.pix}>
                <span className={style.pixLabel}>Chave PIX</span>
                <b>rrnazario@gmail.com</b>
            </div>
            <p className={style.help}>Mais informações? Envie uma mensagem no Telegram para nós. <a href='http://t.me/rrnazario' target={'_blank'} rel='noreferrer'>Clique aqui!</a></p>
        </div>
    </Page>
}
